import { startCase } from "lodash";
import { createSelector } from "reselect";

import { Species } from "constants/species";

import { resolveValue } from "lib/mlaSupplementaryData";
import { isPrimeSaleSubtype, isStoreSaleSubtype } from "lib/sale";

import { getCurrentSaleyard, getCurrentSpeciesId } from "./currentSale";
import { getMLASupplementaryData, getSpecies } from "./root";
import { getCurrentSaleSubType } from "./saleSubTypes";

const requiredMLAFields = (speciesId, saleSubType) => {
  // All Sale Types
  //   Required
  //     Age, Sex
  //
  // Prime Cattle
  //   Required
  //    None
  //   Optional
  //     Breed, Fat Score, Muscle Score, Dressing Percentage
  //
  // Store Cattle
  //   Required
  //     Breed, Estimated Carcasse Weight
  //   Optional
  //     Fat Score, Muscle Score
  //
  // Prime Sheep
  //   Required
  //     Estimated Carcasse Weight
  //   Optional
  //     Breed, Joining, Shearing Status
  //
  // Store Sheep
  //   Required
  //     Frame Size
  //   Optional
  //     Breed, Joining
  const requiredFields = ["ageId", "sexId"];
  if (speciesId === Species.CATTLE) {
    if (isStoreSaleSubtype(saleSubType)) {
      requiredFields.push("breedId", "estCarcassWeight");
    }
  } else if (speciesId === Species.SHEEP) {
    if (isPrimeSaleSubtype(saleSubType)) {
      requiredFields.push("estCarcassWeight");
    }
    if (isStoreSaleSubtype(saleSubType)) {
      requiredFields.push("frameStructure");
    }
  }
  return requiredFields;
};

export const getRequiredMLAFieldsBySubTypeAndSpecies = createSelector(
  [getCurrentSaleSubType, getCurrentSpeciesId, getSpecies],
  (currentSaleSubType, currentSpeciesId, speciesLookup) => {
    const species = speciesLookup[currentSpeciesId] || {};
    return requiredMLAFields(species.id, currentSaleSubType);
  },
);

const generateMLAWarnings = (suppData, requiredFields) => {
  return requiredFields.reduce((warnings, field) => {
    const value = resolveValue(suppData, field, "");
    if (!value) {
      warnings.push(startCase(field));
    }
    return warnings;
  }, []);
};

export const selectMLAFieldWarningsBySaleLotId = createSelector(
  [getMLASupplementaryData, getRequiredMLAFieldsBySubTypeAndSpecies],
  (mlaSupplementaryDataLookup, requiredMLAFields) =>
    Object.entries(mlaSupplementaryDataLookup).reduce(
      (acc, [, mlaSupplementaryData]) => {
        acc[mlaSupplementaryData.saleLot.id] = generateMLAWarnings(
          mlaSupplementaryData,
          requiredMLAFields,
        );
        return acc;
      },
      {},
    ),
);

export const getDefaultRequiredMLAFields = createSelector(
  getRequiredMLAFieldsBySubTypeAndSpecies,
  requiredFields => requiredFields.map(field => startCase(field)),
);

export const getCurrentSaleSubTypeIsMlaEnabled = createSelector(
  [getCurrentSaleSubType, getCurrentSaleyard],
  (currentSaleSubType, currentSaleyard) => {
    return currentSaleyard?.sendMlaAnonymousDataSaleSubTypesIds?.includes(
      currentSaleSubType?.id,
    );
  },
);
